import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ListView from "./partials/ListView";
import { useQuery } from "@apollo/react-hooks";
import { LIST } from "../../queries/appointment.query";
import LoadingSpinner from "../../partials/loading";
import Pagination from "../../partials/pagination";
import { toast } from "react-toastify";
import { CleanMessage, AppName } from "../../util/app";
import FabButton from "../../partials/Buttons/FabButton";
import { EventEmitter } from "../../event/EventEmitter";
import { EVENT_TARGET } from "../../event/model";

const View = ({ match, history }) => {
    // local state
    const [page, setPage] = useState(1);
    const [limit] = useState(25);
    const title = "Appointments";

    // List query
    const { loading, data, fetchMore, refetch } = useQuery(LIST, {
        variables: { page, limit },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    EventEmitter.subscribe(EVENT_TARGET.APPOINTMENT, () => refetch());
    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-head">
                            <header>{title}</header>
                        </div>
                        <div className="card-body m-b-20" style={{ minHeight: "360px" }}>
                            <LoadingSpinner loading={loading} />
                            {!loading && <ListView items={data && data.GetAppointments.docs} match={match} />}
                        </div>
                        {data && (
                            <Pagination
                                {...data.GetAppointments}
                                length={data.GetAppointments.docs.length}
                                onPageClicked={async (page) => {
                                    setPage(page);
                                    await fetchMore({
                                        variables: { page },
                                        updateQuery: (prev, { fetchMoreResult }) => {
                                            if (!fetchMoreResult) return prev;
                                            return {
                                                GetAppointments: fetchMoreResult.GetAppointments,
                                            };
                                        },
                                    });
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>

            <FabButton title="New Appointment" onClick={() => history.push("/home/clinical-note/appointment/create")} />
        </>
    );
};

export default View;
